<template>
    <div class="modal fade" id="cookieBanner" data-bs-backdrop="static" aria-hidden="true" aria-labelledby="cookieBannerLabel" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content bg-white p-4 container">
                <div class="row align-items-center">
                    <div class="col-12 col-lg-8">
                        <h3 class="text-navy">We value your privacy</h3>
                        <p class="text-navy mb-0">We use cookies to help keep our site safe, give you a better experience and show you more relevant ads. Read how we - and our partners - use <a class="text-navy" :href="baseUrl + '/cookies'">cookies</a>. </p>
                    </div>
                    <div class="col-12 col-lg-4">
                        <button data-bs-toggle="modal" data-bs-target="#cookieModalSettings" id="manage" type="button" class="btn btn-light mt-3 me-3 fs-6">No, manage cookies</button>
                        <button @click="acceptCookies" id="confirm" type="button" class="btn btn-primary mt-3 fs-6">Yes, that's fine</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <cookie-modal :advertising-cookie="0" :performance-cookie="0" :functional-cookie="0"></cookie-modal>
</template>

<script>
import cookieModal from '../Modals/CookieModal';
import { Modal } from 'bootstrap';
import {useGtag} from "vue-gtag-next";

export default {
    components: {
        cookieModal
    },
    data() {
        return {
            showCookieBanner: true
        }
    },
    mounted() {
        var myModal = new Modal(document.getElementById('cookieBanner'));
        myModal.show();
                
        this.emitter.on('closeCookieModal', data => {
            myModal.hide();
        });
    },
    methods: {
        async acceptCookies() {
            var response = await axios.post('/ajax/accept_all_cookies');
            const {query} = useGtag();
            
            query('consent', 'update', {
                'analytics_storage': 'granted',
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted'
            });
            
            this.emitter.emit('closeCookieModal', true);
        }
    }
  }
</script>

<style lang="scss" scoped>
    #cookieBanner {
        .modal-dialog {
            max-width: 100%;
            position:fixed;
            top:auto;
            right:auto;
            left:auto;
            bottom: 15px;
            width: 100% !important;
            margin: 0;
            .modal-content {
                border-top: 6px #0064EF solid;
                @media screen and (max-width: 450px) {
                    button {
                        width: 100%;
                    }
                }
            }
        }
    }
</style>